import React, { useEffect, useState } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "./app.css";
import { secretKey } from "./data";
import Loading from "./loading.js";
import {
  faEdit,
  faEye,
  faTrash,
  faCancel,
  faCheck,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const MySwal = withReactContent(Swal2);

const SellerRankEdit = (props) => {
  const [loading, setLoading] = useState(true);
  const [rankData, setRankData] = useState([]);
  const [rankDataClear, setRankDataClear] = useState([]);
  const [filterSeller, setFilterSeller] = useState("");
  const [filterClient, setFilterClient] = useState("");
  const [sources, setSources] = useState([]);

  const onlyUnique = (value, index, array) => {
    return array.indexOf(value) === index;
  };

  const fetchRankData = async () => {
    var body = {};

    await fetch("https://apisplit.ftpeople.pl/getRankDataEdit", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setRankData(
          data.sort(function (a, b) {
            return b.id - a.id;
          })
        );
        setRankDataClear(
          data.sort(function (a, b) {
            return b.id - a.id;
          })
        );
        fetchSources();
      })
      .catch((error) => {});
  };

  const fetchSources = async () => {
    var body = {};

    await fetch("https://apisplit.ftpeople.pl/getLeadSources", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setSources(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    fetchRankData();
  };

  useEffect(() => {
    getData();
  }, []);

  const fetchAddData = async (e) => {
    var body = {
      sellerName: "",
      aggrValue: "",
      aggrSF: "",
      clientName: "",
      clientNameFull: "",
      aggrType: "",
      sfType: "",
      department: "",
      dateRank:
        new Date().getFullYear() +
        "-" +
        (new Date().getMonth() + 1 < 10
          ? "0" + (new Date().getMonth() + 1)
          : new Date().getMonth() + 1) +
        "-" +
        (new Date().getDate() < 10
          ? "0" + new Date().getDate()
          : new Date().getDate()),
      aggrValueCourt: "",
    };

    await fetch("https://apisplit.ftpeople.pl/addRankData", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "HIUHS9820lssj)@(!0",
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        getData();
      })
      .catch((error) => {});
  };

  const fetchUncancelRank = async (e) => {
    var body = {
      id: e.currentTarget.value,
    };

    await fetch("https://apisplit.ftpeople.pl/uncancelRankData", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        getData();
      })
      .catch((error) => {});
  };

  const fetchDeleteRank = async (e) => {
    var body = {
      id: e.currentTarget.value,
    };

    await fetch("https://apisplit.ftpeople.pl/deleteRankData", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        getData();
      })
      .catch((error) => {});
  };

  const fetchEditRank = async (id, field, value) => {
    var body = {
      id: id,
      field: field,
      value: field === "aggrSF" ? value / 100 : value,
    };

    await fetch("https://apisplit.ftpeople.pl/editRankData", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        getData();
      })
      .catch((error) => {});
  };

  const editRank = (e) => {
    var id = e.currentTarget.value;
    var field = e.currentTarget.id;
    var valueP = e.currentTarget.attributes.fieldValue.value;

    MySwal.fire({
      title: "Zmiana",
      input: "text",
      inputValue: valueP,
      cancelButtonText: "Anuluj",
      inputLabel: "nowa wartość",
      showCancelButton: true,
      inputValidator: (value) => {
        fetchEditRank(id, field, value);
      },
    });
  };

  const cancelRank = (e) => {
    var id = e.currentTarget.value;
    var field = e.currentTarget.id;

    MySwal.fire({
      title: "Kiedy wycofanie umowy ma się liczyć w rankingu",
      input: "date",
      cancelButtonText: "Anuluj",
      inputLabel: "nowa wartość",
      showCancelButton: true,
      inputValidator: (value) => {
        fetchEditRank(id, field, value);
      },
    });
  };

  const editRankSource = (e) => {
    var id = e.currentTarget.value;
    var field = e.currentTarget.id;
    var valueP = e.currentTarget.attributes.fieldValue.value;

    var model = [];
    sources.map((el) => {
      model[el.name] = el.name;
    });

    MySwal.fire({
      title: "Wybierz wartość",
      input: "select",
      inputOptions: model,
      inputPlaceholder: "wybierz wartość",
      showCancelButton: true,
      cancelButtonText: "Anuluj",
      inputValidator: function (value) {
        return new Promise(function (resolve, reject) {
          if (value !== "") {
            resolve();
          } else {
            resolve("musisz wybrać wartość");
          }
        });
      },
    }).then(async function (result) {
      if (result.isConfirmed) {
        fetchEditRank(id, field, result.value);
      }
    });
  };

  const handleFilterChange = (value, mode, data) => {
    var arr = data;

    var fText = mode === "filterSeller" ? value : filterSeller;
    if (filterSeller.length > 0 || mode === "filterSeller") {
      arr = arr.filter((el) => el.sellerName.includes(fText));
    }

    var fText = mode === "filterClient" ? value : filterClient;
    if (filterClient.length > 0 || mode === "filterClient") {
      arr = arr.filter((el) => el.clientName.includes(fText));
    }

    setRankData(arr);
  };

  const handleChangeFilterSeller = (e) => {
    setFilterSeller(e.target.value);
    handleFilterChange(e.target.value, "filterSeller", rankDataClear);
  };

  const handleChangeFilterClient = (e) => {
    setFilterClient(e.target.value);
    handleFilterChange(e.target.value, "filterClient", rankDataClear);
  };

  const clearFilters = () => {
    setFilterSeller("");
    setFilterClient("");
    handleFilterChange("", "", rankDataClear);
  };

  const editRankData = (
    <>
      {rankData.length === 0 ? (
        ""
      ) : (
        <>
          <table className="clients_table" style={{ width: "100%" }}>
            <tr>
              <th>ID</th>
              <th>Handlowiec</th>
              <th>Wartość umowy</th>
              <th>Wartość success fee</th>
              <th>Rodzaj success fee</th>
              <th>E-mail klienta</th>
              <th>imię i nazwisko klienta</th>
              <th>Rodzaj umowy</th>
              <th>Dział</th>
              <th>Źródło</th>
              <th>Data</th>
              <th>Potencjalny WPS</th>
              <th>Usuń</th>
            </tr>
            {rankData.map((rank, index) => (
              <>
                <tr
                  style={
                    rank.cancel === "1"
                      ? { backgroundColor: "red", color: "white" }
                      : { backgroundColor: "white", color: "black" }
                  }
                >
                  <td>{rank.id}</td>
                  <td>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                        padding: "0 5px",
                        boxSizing: "border-box",
                      }}
                    >
                      <div
                        style={{
                          width: "60%",
                          display: "flex",
                          justifyContent: "left",
                        }}
                      >
                        {rank.sellerName ? rank.sellerName : "uzupełnij"}
                      </div>
                      <div
                        style={{
                          width: "40%",
                          display: "flex",
                          justifyContent: "center",
                          gap: "15px",
                        }}
                      >
                        <button
                          className="loginButtonLogin"
                          id={"sellerName"}
                          value={rank.id}
                          fieldValue={rank.sellerName}
                          style={{
                            margin: "0",
                            backgroundColor: "transparent",
                            color: "green",
                            border: "none",
                            width: "10%",
                            fontSize: "1vw",
                            padding: "5px 5px",
                          }}
                          onClick={editRank}
                        >
                          <FontAwesomeIcon icon={faEdit} />
                        </button>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                        padding: "0 5px",
                        boxSizing: "border-box",
                      }}
                    >
                      <div
                        style={{
                          width: "60%",
                          display: "flex",
                          justifyContent: "left",
                        }}
                      >
                        {rank.aggrValue ? rank.aggrValue : "uzupełnij"}
                      </div>
                      <div
                        style={{
                          width: "40%",
                          display: "flex",
                          justifyContent: "center",
                          gap: "15px",
                        }}
                      >
                        <button
                          className="loginButtonLogin"
                          id={"aggrValue"}
                          value={rank.id}
                          fieldValue={rank.aggrValue}
                          style={{
                            margin: "0",
                            backgroundColor: "transparent",
                            color: "green",
                            border: "none",
                            width: "10%",
                            fontSize: "1vw",
                            padding: "5px 5px",
                          }}
                          onClick={editRank}
                        >
                          <FontAwesomeIcon icon={faEdit} />
                        </button>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                        padding: "0 5px",
                        boxSizing: "border-box",
                      }}
                    >
                      <div
                        style={{
                          width: "60%",
                          display: "flex",
                          justifyContent: "left",
                        }}
                      >
                        {rank.aggrSF
                          ? rank.sfType === "wartość procentowa"
                            ? (rank.aggrSF * 100).toFixed(0) + "%"
                            : rank.aggrSF
                          : "uzupełnij"}
                      </div>
                      <div
                        style={{
                          width: "40%",
                          display: "flex",
                          justifyContent: "center",
                          gap: "15px",
                        }}
                      >
                        <button
                          className="loginButtonLogin"
                          id={"aggrSF"}
                          value={rank.id}
                          fieldValue={
                            rank.sfType === "wartość procentowa"
                              ? (rank.aggrSF * 100).toFixed(0)
                              : rank.aggrSF
                          }
                          style={{
                            margin: "0",
                            backgroundColor: "transparent",
                            color: "green",
                            border: "none",
                            width: "10%",
                            fontSize: "1vw",
                            padding: "5px 5px",
                          }}
                          onClick={editRank}
                        >
                          <FontAwesomeIcon icon={faEdit} />
                        </button>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                        padding: "0 5px",
                        boxSizing: "border-box",
                      }}
                    >
                      <div
                        style={{
                          width: "60%",
                          display: "flex",
                          justifyContent: "left",
                        }}
                      >
                        {rank.sfType ? rank.sfType : "uzupełnij"}
                      </div>
                      <div
                        style={{
                          width: "40%",
                          display: "flex",
                          justifyContent: "center",
                          gap: "15px",
                        }}
                      >
                        <button
                          className="loginButtonLogin"
                          id={"sfType"}
                          value={rank.id}
                          fieldValue={rank.sfType}
                          style={{
                            margin: "0",
                            backgroundColor: "transparent",
                            color: "green",
                            border: "none",
                            width: "10%",
                            fontSize: "1vw",
                            padding: "5px 5px",
                          }}
                          onClick={editRank}
                        >
                          <FontAwesomeIcon icon={faEdit} />
                        </button>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                        padding: "0 5px",
                        boxSizing: "border-box",
                      }}
                    >
                      <div
                        style={{
                          width: "60%",
                          display: "flex",
                          justifyContent: "left",
                        }}
                      >
                        {rank.clientName ? rank.clientName : "uzupełnij"}
                      </div>
                      <div
                        style={{
                          width: "40%",
                          display: "flex",
                          justifyContent: "center",
                          gap: "15px",
                        }}
                      >
                        <button
                          className="loginButtonLogin"
                          id={"clientName"}
                          value={rank.id}
                          fieldValue={rank.clientName}
                          style={{
                            margin: "0",
                            backgroundColor: "transparent",
                            color: "green",
                            border: "none",
                            width: "10%",
                            fontSize: "1vw",
                            padding: "5px 5px",
                          }}
                          onClick={editRank}
                        >
                          <FontAwesomeIcon icon={faEdit} />
                        </button>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                        padding: "0 5px",
                        boxSizing: "border-box",
                      }}
                    >
                      <div
                        style={{
                          width: "60%",
                          display: "flex",
                          justifyContent: "left",
                        }}
                      >
                        {rank.clientNameFull
                          ? rank.clientNameFull
                          : "uzupełnij"}
                      </div>
                      <div
                        style={{
                          width: "40%",
                          display: "flex",
                          justifyContent: "center",
                          gap: "15px",
                        }}
                      >
                        <button
                          className="loginButtonLogin"
                          id={"clientNameFull"}
                          value={rank.id}
                          fieldValue={rank.clientNameFull}
                          style={{
                            margin: "0",
                            backgroundColor: "transparent",
                            color: "green",
                            border: "none",
                            width: "10%",
                            fontSize: "1vw",
                            padding: "5px 5px",
                          }}
                          onClick={editRank}
                        >
                          <FontAwesomeIcon icon={faEdit} />
                        </button>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                        padding: "0 5px",
                        boxSizing: "border-box",
                      }}
                    >
                      <div
                        style={{
                          width: "60%",
                          display: "flex",
                          justifyContent: "left",
                        }}
                      >
                        {rank.aggrType ? rank.aggrType : "uzupełnij"}
                      </div>
                      <div
                        style={{
                          width: "40%",
                          display: "flex",
                          justifyContent: "center",
                          gap: "15px",
                        }}
                      >
                        <button
                          className="loginButtonLogin"
                          id={"aggrType"}
                          value={rank.id}
                          fieldValue={rank.aggrType}
                          style={{
                            margin: "0",
                            backgroundColor: "transparent",
                            color: "green",
                            border: "none",
                            width: "10%",
                            fontSize: "1vw",
                            padding: "5px 5px",
                          }}
                          onClick={editRank}
                        >
                          <FontAwesomeIcon icon={faEdit} />
                        </button>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                        padding: "0 5px",
                        boxSizing: "border-box",
                      }}
                    >
                      <div
                        style={{
                          width: "60%",
                          display: "flex",
                          justifyContent: "left",
                        }}
                      >
                        {rank.department ? rank.department : "uzupełnij"}
                      </div>
                      <div
                        style={{
                          width: "40%",
                          display: "flex",
                          justifyContent: "center",
                          gap: "15px",
                        }}
                      >
                        <button
                          className="loginButtonLogin"
                          id={"department"}
                          value={rank.id}
                          fieldValue={rank.department}
                          style={{
                            margin: "0",
                            backgroundColor: "transparent",
                            color: "green",
                            border: "none",
                            width: "10%",
                            fontSize: "1vw",
                            padding: "5px 5px",
                          }}
                          onClick={editRank}
                        >
                          <FontAwesomeIcon icon={faEdit} />
                        </button>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                        padding: "0 5px",
                        boxSizing: "border-box",
                      }}
                    >
                      <div
                        style={{
                          width: "60%",
                          display: "flex",
                          justifyContent: "left",
                        }}
                      >
                        {rank.source ? rank.source : "uzupełnij"}
                      </div>
                      <div
                        style={{
                          width: "40%",
                          display: "flex",
                          justifyContent: "center",
                          gap: "15px",
                        }}
                      >
                        <button
                          className="loginButtonLogin"
                          id={"source"}
                          value={rank.id}
                          fieldValue={rank.source}
                          style={{
                            margin: "0",
                            backgroundColor: "transparent",
                            color: "green",
                            border: "none",
                            width: "10%",
                            fontSize: "1vw",
                            padding: "5px 5px",
                          }}
                          onClick={editRankSource}
                        >
                          <FontAwesomeIcon icon={faEdit} />
                        </button>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                        padding: "0 5px",
                        boxSizing: "border-box",
                      }}
                    >
                      <div
                        style={{
                          width: "60%",
                          display: "flex",
                          justifyContent: "left",
                        }}
                      >
                        {rank.date ? rank.date : "uzupełnij"}
                      </div>
                      <div
                        style={{
                          width: "40%",
                          display: "flex",
                          justifyContent: "center",
                          gap: "15px",
                        }}
                      >
                        <button
                          className="loginButtonLogin"
                          id={"date"}
                          value={rank.id}
                          fieldValue={rank.date}
                          style={{
                            margin: "0",
                            backgroundColor: "transparent",
                            color: "green",
                            border: "none",
                            width: "10%",
                            fontSize: "1vw",
                            padding: "5px 5px",
                          }}
                          onClick={editRank}
                        >
                          <FontAwesomeIcon icon={faEdit} />
                        </button>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                        padding: "0 5px",
                        boxSizing: "border-box",
                      }}
                    >
                      <div
                        style={{
                          width: "60%",
                          display: "flex",
                          justifyContent: "left",
                        }}
                      >
                        {rank.aggrValueCourt
                          ? rank.aggrValueCourt
                          : "uzupełnij"}
                      </div>
                      <div
                        style={{
                          width: "40%",
                          display: "flex",
                          justifyContent: "center",
                          gap: "15px",
                        }}
                      >
                        <button
                          className="loginButtonLogin"
                          id={"aggrValueCourt"}
                          value={rank.id}
                          fieldValue={rank.aggrValueCourt}
                          style={{
                            margin: "0",
                            backgroundColor: "transparent",
                            color: "green",
                            border: "none",
                            width: "10%",
                            fontSize: "1vw",
                            padding: "5px 5px",
                          }}
                          onClick={editRank}
                        >
                          <FontAwesomeIcon icon={faEdit} />
                        </button>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                        padding: "0 5px",
                        boxSizing: "border-box",
                      }}
                    >
                      <div
                        style={{
                          width: "40%",
                          display: "flex",
                          justifyContent: "center",
                          gap: "15px",
                        }}
                      >
                        <button
                          className="loginButtonLogin"
                          id={"aggrValueCourt"}
                          value={rank.id}
                          fieldValue={rank.aggrValueCourt}
                          style={{
                            margin: "0",
                            backgroundColor: "transparent",
                            color: "green",
                            border: "none",
                            width: "10%",
                            fontSize: "1vw",
                            padding: "5px 5px",
                          }}
                          onClick={fetchDeleteRank}
                        >
                          <FontAwesomeIcon icon={faTrash} />
                        </button>
                        {rank.cancel === "1" ? (
                          <>
                            <button
                              className="loginButtonLogin"
                              id={"cancel"}
                              value={rank.id}
                              fieldValue={rank.cancel}
                              style={{
                                margin: "0",
                                backgroundColor: "transparent",
                                color: "green",
                                border: "none",
                                width: "10%",
                                fontSize: "1vw",
                                padding: "5px 5px",
                              }}
                              onClick={fetchUncancelRank}
                            >
                              <FontAwesomeIcon icon={faCheck} />
                            </button>
                          </>
                        ) : (
                          <>
                            <button
                              className="loginButtonLogin"
                              id={"cancel"}
                              value={rank.id}
                              fieldValue={rank.cancel}
                              style={{
                                margin: "0",
                                backgroundColor: "transparent",
                                color: "green",
                                border: "none",
                                width: "10%",
                                fontSize: "1vw",
                                padding: "5px 5px",
                              }}
                              onClick={cancelRank}
                            >
                              <FontAwesomeIcon icon={faCancel} />
                            </button>
                          </>
                        )}
                      </div>
                    </div>
                  </td>
                </tr>
              </>
            ))}
          </table>
        </>
      )}
    </>
  );

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <>
          <div
            style={{
              backgroundColor: "white",
              top: "0",
              paddingTop: "5vh",
              paddingBottom: "3vh",
              paddingLeft: "2vw",
              paddingRight: "2vw",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "left",
                alignItems: "end",
                gap: "1vw",
              }}
            >
              <button
                className="loginButtonLogin"
                value="yes"
                style={{
                  margin: "0",
                  backgroundColor: "green",
                  borderColor: "green",
                  width: "180px",
                  height: "3vh",
                }}
                onClick={getData}
              >
                ODŚWIEŻ
              </button>
              <button
                className="loginButtonLogin"
                value="yes"
                style={{
                  margin: "0",
                  backgroundColor: "navy",
                  borderColor: "navy",
                  width: "180px",
                  height: "3vh",
                }}
                onClick={fetchAddData}
              >
                DODAJ
              </button>
              <div style={{ width: "180px", textAlign: "left" }}>
                <p
                  style={{
                    margin: "0",
                    marginBottom: "2px",
                    fontWeight: "600",
                    fontSize: ".6vw",
                    paddingLeft: "2px",
                  }}
                >
                  handlowiec
                </p>
                <input
                  type="text"
                  style={{
                    width: "100%",
                    padding: "0px 10px",
                    boxSizing: "border-box",
                    height: "3vh",
                  }}
                  value={filterSeller}
                  onChange={handleChangeFilterSeller}
                />
              </div>
              <div style={{ width: "180px", textAlign: "left" }}>
                <p
                  style={{
                    margin: "0",
                    marginBottom: "2px",
                    fontWeight: "600",
                    fontSize: ".6vw",
                    paddingLeft: "2px",
                  }}
                >
                  klient
                </p>
                <input
                  type="text"
                  style={{
                    width: "100%",
                    padding: "0px 10px",
                    boxSizing: "border-box",
                    height: "3vh",
                  }}
                  value={filterClient}
                  onChange={handleChangeFilterClient}
                />
              </div>
              <button
                className="loginButtonLogin"
                value="yes"
                style={{
                  margin: "0",
                  backgroundColor: "navy",
                  borderColor: "navy",
                  width: "180px",
                  height: "3vh",
                }}
                onClick={clearFilters}
              >
                WYCZYŚĆ FILTR
              </button>
            </div>
          </div>
          <div
            style={{
              paddingLeft: "2vw",
              paddingBottom: "5vh",
            }}
          >
            {rankData.length === 0 ? (
              <p style={{ textAlign: "left" }}>BRAK DANYCH RANKINGOWYCH</p>
            ) : (
              <>{editRankData}</>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default SellerRankEdit;
